var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FGridWindow',{ref:"gridWindow",attrs:{"url":"/sys/compMng/company/find","config":_vm.windowConfig,"show":_vm.shows,"windowToBody":_vm.appendBody},on:{"onClose":_vm.onClose,"onSelected":_vm.onSelected}})}
var staticRenderFns = []

export { render, staticRenderFns }